import { Link, useLocation } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { founder, salon } from '../../data/content';
import { adminOnlySections, adminSections } from '../../data/adminSections';
import { shopLabels } from '../../data/shopLabels';
import { adminHref } from '../../utils/hosts';
import { btnPrimary, btnSecondary } from '../../ui/styles';
import { closingHeading } from '../../ui/sections';
type Props = {
  title?: string;
  body?: string;
  /** Waar 'terug' naartoe leidt. */
  backTo?: {
    to: string;
    label: string;
  };
};

/** Eén 'niet gevonden'-pagina voor onbekende adressen, producten, artikelen en juridische teksten. */
export function NotFound(props: Props) {
  const {
    pathname
  } = useLocation();
  // Iemand typt /marketing of /klanten: dat staat in het beheer (op /be).
  const path = pathname.replace(/\/$/, '');
  const adminKey = props.backTo ? undefined : adminOnlySections.find(k => adminSections[k].path === path);
  const adminItem = adminKey ? adminSections[adminKey] : undefined;
  const {
    title = adminItem ? `${adminItem.label} staat in het beheer` : 'Deze pagina bestaat niet (meer)',
    body = adminItem ? 'Dit onderdeel is alleen voor de salon en vraagt om in te loggen in het beheer.' : 'Misschien is de link veranderd of verlopen. Begin opnieuw op de homepage of in de webshop, of app me even: ik wijs je de weg.',
    backTo = {
      to: '/',
      label: 'Naar de homepage'
    }
  } = props;
  return <section className="mx-auto flex w-full max-w-content flex-col items-center px-6 py-28 text-center lg:px-10 lg:py-36" aria-labelledby="not-found-title" data-id="element-7934" data-mp="d4qwsvreeyn5">
      {/* "404" is sfeer; de kop zegt al wat er aan de hand is. */}
      <p className="font-display text-7xl font-light text-clay" aria-hidden="true" data-id="element-7935" data-mp="83kz0jivsl6r">
        404
      </p>
      <h1 id="not-found-title" className={`mt-6 max-w-lg ${closingHeading} text-ink`} data-id="element-7936" data-mp="1xir81ii1qjd8">
        {title}
      </h1>
      <p className="mt-4 max-w-md text-[16px] leading-relaxed text-muted" data-id="element-7937" data-mp="22hudh41xurlq">{body}</p>
      <div className="mt-9 flex flex-wrap justify-center gap-3" data-id="element-7938" data-mp="2105iuf00ais7">
        {adminItem ?
      // Een gewone link: het beheer is een los deel (en straks een ander domein).
      <a href={adminHref(adminItem.path)} className={btnPrimary} data-id="element-7939" data-mp="1w3orzd1f9qbf">
            Naar het beheer
          </a> : <Link to={backTo.to} className={btnPrimary} data-id="element-7940" data-mp="1n15sn2wuhvtx">
            {backTo.label}
          </Link>}
        {backTo.to !== '/webshop' && <Link to="/webshop" className={btnSecondary} data-id="element-7941" data-mp="2jq522l9613np">
            Webshop
          </Link>}
        <a href={salon.whatsapp} target="_blank" rel="noopener noreferrer" className={btnSecondary} data-id="element-7942" data-mp="2esln1j4n8mup">
          <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-7943" data-mp="29zahdlbkic4d" />
          Vraag het {founder.firstName}
          <span className="sr-only" data-id="element-7944" data-mp="32hecqxuo9ygv">{shopLabels.viaWhatsApp}</span>
        </a>
      </div>
    </section>;
}